import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Megaphone, ShieldCheck, Upload } from 'lucide-react';
const services = [{
  icon: Upload,
  title: 'Publishing & Distribution',
  description: 'Full-service management of platform relationships (Steam, Console, Epic) and release strategy.'
}, {
  icon: Megaphone,
  title: 'Marketing & Community',
  description: 'Building hype where it matters. Influencer outreach, social media management, and community building.'
}, {
  icon: Globe,
  title: 'Localization Support',
  description: 'Translating fear into every language. Cultural adaptation to ensure your horror hits home globally.'
}, {
  icon: ShieldCheck,
  title: 'Quality Assurance',
  description: 'Rigorous testing to ensure the only bugs in your game are the ones you designed to be there.'
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-shadow relative overflow-hidden" data-id="element-137">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-mystic-900 to-transparent opacity-50" data-id="element-138" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-139">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-140">
          <div data-id="element-141">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-142">
              Forging <span className="text-mystic-500" data-id="element-143">Nightmares</span>{' '}
              Together
            </h2>
            <p className="text-gray-400 text-lg mb-8" data-id="element-144">
              We offer a comprehensive suite of services tailored specifically
              for the needs of horror game developers. You focus on the craft;
              we handle the business of fear.
            </p>

            <div className="p-6 bg-abyss border border-white/5 rounded-lg" data-id="element-145">
              <h4 className="text-white font-serif font-bold mb-2" data-id="element-146">
                Ready to submit your prototype?
              </h4>
              <p className="text-sm text-gray-500 mb-4" data-id="element-147">
                We are currently accepting pitches for Q3 2026 release windows.
              </p>
              <button className="text-mystic-400 text-sm font-bold uppercase tracking-wider hover:text-white transition-colors flex items-center gap-2" data-id="element-148">
                Review Submission Guidelines &rarr;
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-149">
            {services.map((service, index) => <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-abyss p-6 rounded-lg border border-white/5 hover:border-mystic-500/30 transition-colors" data-id="element-150">
                <service.icon className="w-8 h-8 text-mystic-500 mb-4" data-id="element-151" />
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-152">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-153">{service.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}